module.exports = __webpack_public_path__ + "static/img/why-micro-4.413f375b.svg";